<template>
  <v-dialog
      v-model="showDialog"
      max-width="800px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Default bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <h5 style="color: black">Standartwert</h5>
          <v-select
              :items="dataTypes"
              label="Datentyp"
              :rules="[rules.required]"
              v-model="entry.data_type"
          ></v-select>
          <v-select
              :items="contentTypes[entry.data_type]"
              label="Inhalt"
              v-model="entry.content"
              v-if="entry.data_type !== 'fixed'"
              :rules="[rules.required]"
          ></v-select>
          <v-textarea
              v-else
              label="Inhalt"
              v-model="entry.content"
          ></v-textarea>
          <v-select
              v-if="formats[entry.data_type] && formats[entry.data_type].length && entry.data_type !== 'date'"
              :items="formats[entry.data_type]"
              label="Format"
              v-model="entry.format"
              :rules="[rules.required]"
          ></v-select>
          <v-select
              v-if="entry.data_type === 'string' && (entry.content === 'ab_invoice.hh_ein' || entry.content === 'ab_invoice.hh_aus')"
              :items="kontoTypes"
              label="Format"
              v-model="entry.format"
          ></v-select>
          <v-combobox
              v-if="entry.data_type === 'date'"
              :items="formats['date']"
              label="Format"
              v-model="entry.format"
              hint="DD.MM.YYYY -> 31.12.2026"
              :rules="[rules.required]"
          ></v-combobox>
          <h5 style="color: black">Datenlänge</h5>
          <v-text-field
              label="Feldlänge"
              v-model="entry.field_length"
              hint="Für Zahlen größer 0 wird die Länge über die unteren Operationen angepasst."
          ></v-text-field>
          <v-select
              :items="trimTypes"
              label="Abschneiden"
              v-model="entry.trim"
              hint="Auf welcher Seite soll abgeschnitten werden?"
          ></v-select>
          <v-text-field
              label="Auffüllen von links"
              v-model="entry.pad_left"
              hint="Mit diesen Buchstaben/Zeichen wird von links augefüllt"
          ></v-text-field>
          <v-text-field
              label="Auffüllen von rechts"
              v-model="entry.pad_right"
              hint="Mit diesen Buchstaben/Zeichen wird von links augefüllt"
          ></v-text-field>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="red darken-1"
            text
            @click="showDialog = false; $emit('submit', undefined)"
        >
          Löschen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
        >
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: "LowerLevelEntryDialog",
  props: {
    entryProp: {
      type: Object,
      default: () => {
        return {
          id: "new",
          definition_id: "",
          entry_type: "default",
          parent_id: "",
          order_number: 0,
          title: "",
          data_type: "",
          content: "",
          field_length: -1,
          format: "",
          trim: "right",
          pad_left: "",
          pad_right: "",
          additional_properties: {},
        }
      },
    },
    konto_setting: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Muss gesetzt sein.',
    },
    showDialog: false,
    error: false,
    entry: {
      id: "new",
      definition_id: "",
      entry_type: "default",
      parent_id: "",
      order_number: 0,
      title: "",
      data_type: "",
      content: "",
      field_length: -1,
      format: "",
      trim: "right",
      pad_left: "",
      pad_right: "",
      additional_properties: {},
    },
    internalDefaults: {},
    entryTypes: ["default", "assumption", "payout", "extern", "eigen"],
    dataTypes: [
      {text: 'Text', value: "string"},
      {text: 'Ganzahl (positiv)', value: "integer"},
      {text: 'Ganzahl (negativ)', value: "integer_negative"},
      {text: 'Dezimalzal (positiv)', value: "float"},
      {text: 'Dezimalzal (negativ)', value: "float_negative"},
      {text: 'Datum', value: "date"},
      {text: 'Wahrheitswert', value: "boolean"},
      {text: 'Festwert', value: "fixed"},
    ],
    formats: {
      "float": [{text: 'Komma-Getrennt', value: "float_comma"}, {text: 'Punkt-Getrennt', value: "float_dot"}],
      "float_negative": [{text: 'Komma-Getrennt', value: "float_comma"}, {text: 'Punkt-Getrennt', value: "float_dot"}],
      "integer": [{text: 'Normal', value: ""}, {text: 'Prozent', value: "float_percent"}],
      "integer_negative": [{text: 'Normal', value: ""}, {text: 'Prozent', value: "float_percent"}],
      "date": ["DD.MM.YYYY", "DD.MM.YY", "DD.MM.YY", "MM.YYYY", "DD", "MM", "YYYY", "YY"],
    },
    trimTypes: [
      {text: 'Links abschneiden', value: "left"},
      {text: 'Rechts abschneiden', value: "right"},
    ],
    kontoTypes: [{text: 'komplett', value: ""}],
    contentTypes: {
      "string": [
        {text: 'Rechnungsnummer', value: "ab_invoice.invoice_number"},
        {text: 'Konto-Einnahme', value: "ab_invoice.hh_ein"},
        {text: 'Konto-Einnahme-Text', value: "ab_invoice.hh_ein_txt"},
        {text: 'Konto-Ausgabe', value: "ab_invoice.hh_aus"},
        {text: 'Konto-Ausgabe-Text', value: "ab_invoice.hh_aus_txt"},

        {text: 'Auftragsnummer', value: "bd_auftrag.aufisn"},
        {text: 'Unterauftragsnummer', value: "bd_auftrag.pos_nr"},
        {text: 'Auftrag-Wo', value: "bd_auftrag.object"},
        {text: 'Auftrag-Was', value: "bd_auftrag.task"},
        {text: 'Auftrag-Inter/Extern', value: "bd_auftrag.task_type_1"},
        {text: 'Auftragsart', value: "bd_auftrag.art_auf"},
        {text: 'Sachbearbeiter', value: "bd_auftrag.clerk"},
        {text: 'Sachbearbeiter-Telefon', value: "bd_auftrag.clerk_tel"},
        {text: 'Auftrag-Memo', value: "bd_auftrag.memo"},
        {text: 'Auftraggeber-Anrede', value: "bd_auftrag.salutation"},
        {text: "Auftraggeber-Name1", value: "bd_auftrag.name_1"},
        {text: "Auftraggeber-Name2", value: "bd_auftrag.name_2"},
        {text: "Auftraggeber-Straße", value: "bd_auftrag.street"},
        {text: "Auftraggeber-Plz", value: "bd_auftrag.zip_code"},
        {text: "Auftraggeber-Ort", value: "bd_auftrag.city"},
        {text: "Auftrag-Belegnr-Extern", value: "bd_auftrag.beleg_ex"},
        {text: "Auftrag-Abrechnungs-Kenz.", value: "bd_auftrag.nkr_kasse"},
        {text: "Rechnung-Anrede", value: "bd_auftrag.re_anrede"},
        {text: "Rechnung-Name", value: "bd_auftrag.re_vorname"},
        {text: "Rechnung-Zu-Händen", value: "bd_auftrag.re_name_1"},
        {text: "Rechnung-Straße", value: "bd_auftrag.re_strh_nr"},
        {text: "Rechnung-Land", value: "bd_auftrag.re_land"},
        {text: "Rechnung-Plz", value: "bd_auftrag.re_plz"},
        {text: "Rechnung-Ort", value: "bd_auftrag.re_ort"},
        {text: "Rechnung-PK-Nummer", value: "bd_auftrag.re_nr"},
      ],
      "float": [{text: 'Rechnungspreis', value: "ab_invoice.price"}],
      "float_negative": [{text: 'Rechnungspreis', value: "ab_invoice.price"}],
      "integer": [{text: 'Rechnungspreis', value: "ab_invoice.price"},  {text: "Auftrag-MWST-Prozent", value: "bd_auftrag.mwst_percentage"},],
      "integer_negative": [{text: 'Rechnungspreis', value: "ab_invoice.price"},  {text: "Auftrag-MWST-Prozent", value: "bd_auftrag.mwst_percentage"},],
      "date": [{text: 'Rechnungsdatum', value: "ab_invoice.create_date"}, {text: "aktuelles Datum", value: "now()"}],
    },
  }),
  methods: {
    show() {
      if (this.showDialog) {
        return;
      }
      this.entry = {...this.entryProp};
      this.kontoTypes = [{text: 'komplett', value: ""}];
      for (let i = 0; i < this.konto_setting.length; i++) {
        this.kontoTypes.push({text: this.konto_setting[i], value: this.konto_setting[i]})
      }
      this.showDialog = true;
    },
    submit() {
      try {
        this.entry.field_length = parseInt(this.entry.field_length, 10)
      } catch (e) {
        this.entry.field_length = -1
      }
      this.$emit('submit', this.entry);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>

</style>
